export default {
  name: {
    number: "採購單號",
    date: "日期",
    end_date: "交貨期",
  },
};
